// components/Faq.js
import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const Faq = () => {
  const [expandedFaq, setExpandedFaq] = useState(null);

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "How does your platform scale for enterprise organizations?",
      answer:
        "Our platform is built with enterprise scalability at its core, supporting organizations from 100 to 100,000+ employees. We provide flexible deployment options including cloud, on-premise, and hybrid solutions, with infrastructure that scales as your needs grow."
    },
    {
      question: "What's included in enterprise implementation and onboarding?",
      answer:
        "Enterprise implementation includes dedicated project management, integration planning, data migration support, comprehensive staff training, and a 90-day success framework. Onboarding typically takes 4–8 weeks depending on scope and complexity."
    },
    {
      question: "Can you integrate with our existing enterprise systems?",
      answer:
        "Yes. We offer extensive integration capabilities with major enterprise systems including SAP, Salesforce, Microsoft 365, Google Workspace, and many others via our API-first architecture and pre-built connectors."
    },
    {
      question: "What kind of ROI can we expect from AI transformation?",
      answer:
        "Our enterprise clients typically see 25–40% productivity improvements within six months and an average ROI of 300–500% within the first year. Actual outcomes vary based on implementation scope, maturity, and industry."
    },
    {
      question: "How do you support change management and user adoption?",
      answer:
        "We provide comprehensive change management support including executive coaching, role-specific training, user adoption analytics, internal communication assets, and ongoing success management to ensure sustainable adoption."
    },
    {
      question: "What's your approach to custom AI solutions for enterprises?",
      answer:
        "We begin with a structured discovery and assessment of your business processes, then move to solution design, pilot implementation, and scaled deployment—aligned with your industry, governance, and compliance requirements."
    },
    {
      question: "How does enterprise pricing work?",
      answer:
        "Enterprise pricing is tailored to your requirements, user volume, and deployment complexity. We offer flexible models including annual subscriptions, multi-year agreements, and custom pricing for large-scale implementations."
    },
    {
      question: "What ongoing support do enterprise customers receive?",
      answer:
        "Enterprise customers receive 24/7 priority support, dedicated account management, quarterly business reviews, early access to new features, and continuous training resources to maximize value over time."
    }
  ];

  return (
    <div className="bg-white py-10 sm:py-20 lg:py-20 text-gray-700">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin tracking-wide mb-4">
            Frequently Asked <em className="text-gray-900">Questions</em>
          </h2>
          <p className="text-sm sm:text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Answers to common questions about our enterprise AI solutions, implementation, and support.
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = expandedFaq === index;
            return (
              <div
                key={index}
                className="border-b border-gray-200"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full text-left py-4 sm:py-5 flex justify-between items-center hover:text-black transition-colors"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm sm:text-base md:text-lg font-light tracking-wide pr-4 sm:pr-8">
                    {faq.question}
                  </span>
                  <span className="flex-shrink-0 text-gray-500">
                    {isOpen ? (
                      <ChevronUp className="w-5 h-5" aria-hidden="true" />
                    ) : (
                      <ChevronDown className="w-5 h-5" aria-hidden="true" />
                    )}
                  </span>
                </button>
                {isOpen && (
                  <div className="pb-4 sm:pb-6 text-gray-700 leading-relaxed text-sm sm:text-base">
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Faq;
